const firstStepConstants = {
	flights : [
               { value: 1, label: 'Elevator'},
               { value: 2, label: 'Walk Up'},
        ],
	moveSizesHouse : [
                { value: 1, label: '1st – 10th floor', floor: 1 },
                { value: 2, label: '11th – 20th floor', floor: 2 },
                { value: 3, label: '21st - 30th floor', floor: 3 },
                { value: 4, label: '31st + floor', floor: 4 }
        ],
        moveSizesHouseFloor : [
                { value: 1, label: 'Elevator Building', floor: 1 },
                { value: 2, label: 'Stair Carry', floor: 2 }
        ],
        moveSizes : [
                { value: 1, label: 'Studio'},
                { value: 2, label: '1 bedroom'},
                { value: 3, label: '2 bedroom'},
                { value: 4, label: '3 bedroom'}
        ],
        homeType : [
                { value: 1, label: 'Studio' },
                { value: 2, label: '1br apt' },
                { value: 3, label: '2br apt' },
                { value: 4, label: '3br+ apt' },
                { value: 5, label: 'Villa' },
                { value: 6, label: 'Office' }
	],
        storageAcOption : [
                { value: 1, label: 'A/C Storage'},
                { value: 2, label: 'Non A/C Storage' }
        ],
        baseLocation:  {
                lat: 25.1465667,
                lng: 55.2254351
                }
};

export default firstStepConstants;



// WEBPACK FOOTER //
// ./src/common/Constants.js